import type { GeometryDataTyped, Point3 } from "@/types/blocks.types";

export enum ParametricAssetId {
  SLAB_BRIDGE_EXTRADOS = "slab-bridge-extrados",
  SLAB_BRIDGE_INTRADOS = "slab-bridge-intrados",
  ABUTMENT = "abutment",
  WING_WALL = "wing-wall",
  TRAPEZOIDAL_PIER = "trapezoidal-pier",
  CANTILEVER = "cantilever",
  CANTILEVER_2 = "cantilever-2",
  CANTILEVER_3 = "cantilever-3",
  CANTILEVER_REINFORCEMENT = "cantilever-reinforcement",
  CULVERT_HEADWALL = "culvert-headwall",
  CULVERT_UNFOLDED_VIEW = "culvert-unfolded-view",
  BEAM_BRIDGE = "beam-bridge",
  TUNNEL_HEAD = "tunnel-head",
  RECTANGLE = "rectangle",
}

export enum SubmittingOrganization {
  ARS = "ars",
  GETEC = "getec",
  PCM = "pcm",
  SITES = "sites",
}

export type ParametricAssetInputType =
  | "dimension"
  | "angle"
  | "quantity"
  | "boolean";

export interface ParametricAsset<T extends Record<string, boolean | number>> {
  id: ParametricAssetId;
  image: string;
  imageToShow?: (data: T) => string;
  submittedBy?: SubmittingOrganization;
  inputs: {
    key: string;
    type: ParametricAssetInputType;
    booleanLabels?: { true: string; false: string };
  }[];
  inputsToShow?: (data: T) => (keyof T)[];
  build: (params: T, offset: Point3) => GeometryDataTyped[];
}
